import { useRoutes } from 'react-router-dom';

// routes
// import MainRoutes from './MainRoutes';
// import AuthenticationRoutes from './AuthenticationRoutes';
import PublicRoute from './PublicRoute';
import PrivateRoute from './PrivateRoutes';
import ClientRoutes from './ClientRoutes';
import config from 'config';
import ProfileRoutes from './ProfileRoutes';
import OtherLoginRoutes from './OtherLoginRoutes';
import ResetPasswordWrapper from "../views/common-components/ResetPasswordWrapper";

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {

    const ResetPasswordRoute = {
        path: "/reset-password",
        element: <ResetPasswordWrapper />
    };

    return useRoutes([PublicRoute, ResetPasswordRoute, PrivateRoute, ProfileRoutes ,ClientRoutes, OtherLoginRoutes]);
}
